export default __webpack_public_path__ + "static/media/pandareads.4083cd75.png";